<template>
    <form method="post" id="verifyform" enctype="multipart/form-data">
        <div class="grid grid-cols-3 gap-4">

            
            <div>
                <FloatLabel class="w-full" variant="on">
					<InputText v-model="veryfyCode" class="w-full" type="text"  name="veryfyCode"/>
					<label for="veryfyCode">Codice di verifica *</label>
				</FloatLabel>
            </div>
            <div>
                <FloatLabel class="w-full" variant="on">
					<InputText v-model="email" class="w-full" type="email" name="email"/>
					<label for="email"> Email *</label>
				</FloatLabel>
            </div>
            <div class="text-right">                
                <Button @click="verifyTicket" class="bottone-salva btn btn-primario mt-4 mr-2">Verifica</Button>
            </div>
        </div>
</form>
</template>
  
  <script>
  
  import InputText from 'primevue/inputtext';
import FloatLabel from 'primevue/floatlabel';
import Button from 'primevue/button';

  
  export default {
    name: "VerifyTicketForm",
    components: {
		InputText,
		FloatLabel,
		Button,
	},
    props: ['action'],
    data() {
      return {
        veryfyCode: '',
        email: '',
      };
    },
    methods: {
        verifyTicket() {
            window.location.href = "/support/verifica/thread?code=" + this.veryfyCode + "&email=" + this.email;
            
        }
    }
  }
  </script>
  
  <style scoped>
  
  </style>